import { gql } from '@apollo/client';
import { PUBLIC_API_PERMISSION_ITEM_FRAGMENT } from './public-api-permissions.fragments';

export const GET_PUBLIC_API_PERMISSIONS_QUERY = gql`
  query GetPublicApiPermissions {
    getPublicApiPermissions {
      items {
        ...PublicApiPermissionItemFields
      }
    }
  }
  ${PUBLIC_API_PERMISSION_ITEM_FRAGMENT}
`;
